__turbopack_context__.v({
  "box": "catalog-filters-module-scss-module__JK6Rta__box",
  "caption": "catalog-filters-module-scss-module__JK6Rta__caption",
  "color": "catalog-filters-module-scss-module__JK6Rta__color",
  "colors": "catalog-filters-module-scss-module__JK6Rta__colors",
  "dot": "catalog-filters-module-scss-module__JK6Rta__dot",
  "group": "catalog-filters-module-scss-module__JK6Rta__group",
  "groups": "catalog-filters-module-scss-module__JK6Rta__groups",
  "link": "catalog-filters-module-scss-module__JK6Rta__link",
  "mobile-bar": "catalog-filters-module-scss-module__JK6Rta__mobile-bar",
  "option": "catalog-filters-module-scss-module__JK6Rta__option",
  "radio": "catalog-filters-module-scss-module__JK6Rta__radio",
  "sheet": "catalog-filters-module-scss-module__JK6Rta__sheet",
  "sheet-actions": "catalog-filters-module-scss-module__JK6Rta__sheet-actions",
  "sidebar": "catalog-filters-module-scss-module__JK6Rta__sidebar",
  "size": "catalog-filters-module-scss-module__JK6Rta__size",
  "sizes": "catalog-filters-module-scss-module__JK6Rta__sizes",
  "title": "catalog-filters-module-scss-module__JK6Rta__title",
});
